import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const IncidentCellListUploadRequest = (filePath, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RanReportKpis/IncidentCellListUpload`,
	params: { filePath, userId }
});

export const IncidentCellListExportRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RanReportKpis/IncidentCellListExport`,
	data: { userId }
});
